import type { NoiseHudSnapshot } from "../../../features/noise-extraction";
import { t } from "../../../data/strings";

export function topHtml(): string {
  return `
    <div class="ne-top-bar">
      <div class="ne-top-stats">
        <span class="ne-chip ne-chip-value" data-ne-value></span>
        <span class="ne-alert" data-ne-alert data-tier="0"></span>
        <span class="ne-cause" data-ne-cause></span>
      </div>
      <div class="ne-top-actions">
        <button type="button" class="ne-btn" data-ne-restart>${t("noise.hud.restart")}</button>
        <button type="button" class="ne-btn ne-btn-quit" data-ne-quit>${t("noise.hud.quit")}</button>
      </div>
    </div>
  `;
}

export function resultHtml(snap: NoiseHudSnapshot): string {
  const title = snap.endMessageKey ? t(snap.endMessageKey) : "";
  const bodyKey =
    snap.endResult === "escaped"
      ? "noise.result.escapedBody"
      : "noise.result.caughtBody";
  return `
    <div class="ne-result">
      <div class="ne-result-title">${title}</div>
      <div class="ne-result-body">${t(bodyKey)}</div>
      <div class="ne-result-stats">${t("noise.result.stats", {
        value: String(snap.carryingValue),
        alert: snap.alerted ? "1" : "0",
      })}</div>
      <div class="ne-result-actions">
        <button type="button" class="ne-btn" data-ne-again>${t("noise.hud.restart")}</button>
        <button type="button" class="ne-btn ne-btn-quit" data-ne-quit-modal>${t("noise.hud.quit")}</button>
      </div>
    </div>
  `;
}
